import { useEffect, useState } from 'react';
import { Form, Input, Button, Typography, App } from 'antd';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { api } from '../../services/api';
import logo from '../../assets/branding/logo.png';
import './login.css';

export default function LoginPage() {
  const { token, setSession } = useAuth();
  const nav = useNavigate();
  const { message } = App.useApp();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (token) nav('/', { replace: true });
  }, [token, nav]);

  const onFinish = async (values: { username: string; password: string }) => {
    setLoading(true);
    try {
      const res = await api.login(values.username, values.password);
      setSession(res.token, res.username);
      message.success('登录成功');
      nav('/', { replace: true });
    } catch (e) {
      message.error(e instanceof Error ? e.message : '登录失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-grid" />
      <div className="login-orb login-orb-a" />
      <div className="login-orb login-orb-b" />

      <div className="login-stack">
        <div className="login-hero">
          <img src={logo} alt="MOCUT Assets" className="login-logo" />
          <div className="login-brand tech-title">MOCUT ASSETS</div>
          <Typography.Paragraph className="login-tagline">
            统一管理图片、视频、音效与 BGM，安全高效地供给第三方应用。
          </Typography.Paragraph>
        </div>

        <div className="login-card tech-panel">
          <div className="login-card-head">
            <div>
              <div className="login-card-title">控制台登录</div>
              <div className="login-card-sub">安全接入 · 资源中枢</div>
            </div>
          </div>
          <Form layout="vertical" onFinish={onFinish} requiredMark={false} size="large">
            <Form.Item
              name="username"
              label="用户名"
              rules={[{ required: true, message: '请输入用户名' }]}
              initialValue="admin"
            >
              <Input prefix={<UserOutlined />} placeholder="admin" autoComplete="username" />
            </Form.Item>
            <Form.Item
              name="password"
              label="密码"
              rules={[{ required: true, message: '请输入密码' }]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="请输入密码"
                autoComplete="current-password"
              />
            </Form.Item>
            <Button type="primary" htmlType="submit" block loading={loading} className="login-submit">
              进入系统
            </Button>
          </Form>
        </div>
      </div>
    </div>
  );
}
